import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import PropTypes from 'prop-types';
import {
  View,
  TouchableOpacity,
  Animated,
  Easing,
  Platform,
} from 'react-native';
import { CrossIcon, WarningIcon, ErrorIcon } from '../../../components/common/icons';
import Text from '@dbk/ui-text';
import styles from './dismissable-bar.styles';
import { PALETTE } from '../../../constants';

class DismissableBar extends PureComponent {
  state = { dismissed: false }

  dismiss = (error, key) => this.props.deleteRecord(error, key);

  render() {
    const { dismissed } = this.state;
    const {
      error: { errorType, errorDesc , sevType},
      error,
      keyValue,
      i18n: {messages}
    } = this.props;

    if(sevType === "Ignore") return null;
    const errorTypeText = (errorType === 'Error') ? messages['app.payments.confirmation.error'] : messages['app.warning.text'];
    return (
      <View style={ errorType === "Error" ? styles.rootError : styles.rootWarning}>
        <View style={styles.iconType}>
          {errorType === "Error" ?
          <ErrorIcon width={30} height={30}/> :
          <WarningIcon width={30} height={30} color={PALETTE.warning}/>}
        </View>
        <View style={styles.typeMessage}>
          <Text size="large" className="payment-summary-index" aria-label={errorTypeText} role="alert" tabIndex="0">{errorTypeText}</Text>
          <Text size="small" className="payment-summary-index" aria-label={errorDesc} role="alert" tabIndex="0">{errorDesc}</Text>
        </View>
        <View style={styles.closeMark}>
          <TouchableOpacity style={styles.closeContainer} onPress={(e) => this.dismiss(error, keyValue)} accessibilityLabel={messages['app.chedelivery.reports.close']} accessibilityRole='button'>
            <CrossIcon color={"#999"} height={30} width={30} />
          </TouchableOpacity>
        </View>
      </View>
    );
  }
}

DismissableBar.propTypes = {
  dismissed: PropTypes.bool,
  setDismissed: PropTypes.func,
  errorType: PropTypes.string,
};

DismissableBar.defaultProps = {
  dismissed: false,
  errorType: "Error"
};

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    }
  }
})(DismissableBar)
